import { initializeApp } from 'firebase/app'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getStorage, connectStorageEmulator } from 'firebase/storage'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'

/**
 * Firebase configuration
 * Uses the same configuration as the main app
 */
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "your-api-key",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "your-project.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "your-project-id",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "your-project.appspot.com",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "your-sender-id",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "your-app-id"
}

// Initialize Firebase app
const app = initializeApp(firebaseConfig)

// Firestore database instance
export const db = getFirestore(app)

// Firebase Authentication instance
export const auth = getAuth(app)

// Firebase Storage instance
export const storage = getStorage(app)

// Firebase Functions instance - configured for asia-southeast1 region
export const functions = getFunctions(app, 'asia-southeast1')

// Connect to Firebase Emulators when VITE_USE_EMULATORS=true (local dev only)
// .env.local is gitignored, so production builds won't have this set
if (import.meta.env.VITE_USE_EMULATORS === 'true') {
  const emulatorHost = import.meta.env.VITE_EMULATOR_HOST || 'localhost'
  connectAuthEmulator(auth, `http://${emulatorHost}:9099`, { disableWarnings: true })
  connectFirestoreEmulator(db, emulatorHost, 8080)
  connectStorageEmulator(storage, emulatorHost, 9199)
  connectFunctionsEmulator(functions, emulatorHost, 5001)
  console.log(`🔧 Tournament Viewer connected to Firebase Emulators at ${emulatorHost}`)
}

export default app
